import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMapStore = defineStore('Map', () => {
  const featureUrlPath = ref('');
  const updateUrlPath = ref('');
  return { featureUrlPath, updateUrlPath };
});
